"use client";

import { trim } from "mediatools";
import { baseName } from "../_components/format";
import { type TimeRange, TimeRangeOptionsForm } from "./forms";
import type { MediaOperation } from "./types";

export const trimAudioOperation: MediaOperation<TimeRange> = {
  id: "trim-audio",
  group: "audio",
  inputKinds: ["audio"],
  outputKind: "audio",
  needsDecodedAudio: true,
  showSourcePreview: true,
  defaultOptions: { start: 0, end: 0 },
  OptionsForm: TimeRangeOptionsForm,
  run: async (ctx, options) => {
    if (!ctx.file || !ctx.decoded) throw new Error("No file loaded.");
    const pcm = trim(ctx.decoded, options);
    return { pcm, baseName: `${baseName(ctx.file.name)}-trimmed` };
  },
};
